import type { FormatType, MatchScoringMatchHole } from '@golf-app/shared';

export type MatchScoringEntryMode = 'detailed' | 'quick-hole' | 'manual-result';

/**
 * Manual-result rounds never have a hole-entry workflow. Every other format
 * follows the server capability so a new unsupported format fails closed to
 * quick results instead of accidentally posting a detailed score batch.
 */
export function matchScoringEntryMode(
  formatType: FormatType,
  supportsDetailedScoring: boolean,
): MatchScoringEntryMode {
  if (formatType === 'manual_result_only') return 'manual-result';
  return supportsDetailedScoring ? 'detailed' : 'quick-hole';
}

/** Finds the next unscored hole, wrapping once from 18 back to 1. */
export function nextOpenMatchHole(
  matchHoles: MatchScoringMatchHole[],
  currentHole: number,
  totalHoles = 18,
): number {
  const completed = new Set(
    matchHoles
      .filter((hole) => hole.status === 'completed')
      .map((hole) => hole.holeNumber),
  );
  for (let offset = 1; offset <= totalHoles; offset += 1) {
    const hole = ((currentHole - 1 + offset) % totalHoles) + 1;
    if (!completed.has(hole)) return hole;
  }
  return currentHole;
}
